import { DraftActions } from '../actions/actionTypes'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = ''

const reducer = ReducerBuilder.create<string, string>(INITIAL_STATE)
  .mapAction(DraftActions.PREVIEW_DOCUMENT, (state, payload) => payload)
  .build()

export default reducer
